import amplitude from 'amplitude-js'
import ObjectId from 'bson-objectid'
import * as UserUtils from '../utils/user'

const key =
  process.env.REACT_APP_ENV === 'production'
    ? 'c720affbd112e1fba5b3058292313684'
    : '8094dd1c9ea36844867f8e1d360d067e'

class Amplitude {
  constructor() {
    this.amp = amplitude.getInstance()
    this.amp.init(key)
    window.AMP_CLIENT = this.amp
    this.context = 'trial-form'
    this.sessionId = ObjectId().str
  }

  setUser(user) {
    try {
      this.email = user.email
      this.licence = UserUtils.getLicence(user)
      this.organization = UserUtils.getOrganization(user)
      this.company = user.company
      this.job = user.job
      this.sport = user.sport
      this.phone_code = user.phone_code
      this.language = user.language
      this.referral = user.referral

      this.amp.setUserId(this.email)
      window.MetricaSportsAnalytics.setUser(user._id, user)
    } catch (e) {
      console.warn('Could not set up user in Amplitude')
    }
  }

  logEvent(action) {
    const amp = this.amp
    const isProd = process.env.REACT_APP_ENV === 'production'
    const eventOptions = {
      action: action || undefined,
      context: this.context,
      licence: this.licence,
      organization: this.organization,
      sessionId: this.sessionId,
      user: this.email,
      company: this.company,
      job: this.job,
      sport: this.sport,
      phone_code: this.phone_code,
      language: this.language,
      referral: this.referral
    }

    return new Promise((resolve, reject) => {
      amp.logEvent(action, eventOptions, (statusCode, data, reason) => {
        if (data !== 'success') {
          if (!isProd) {
            console.log(`Amplitud event: ${action} ERROR`, reason)
          }

          return reject(reason)
        }

        if (!isProd) {
          console.log(`Amplitud event: ${action} registered`)
        }

        return resolve(data)
      })
    })
  }
}

// Amplitud Event
// {
//   action: string (comes from the constants for Analytics),
//   context: 'metrica-trial',
//   licence: mainLicence.licence.code,
//   organization: mainLicence.organization.code,
//   sessionId: generate or get a session ID,
//   user: user's email,
//   company: user's company,
//   job: user's job,
//   sport: user's sport,
//   referral: user's referral,
//   language: user's language
// }

export default new Amplitude()
